import type React from "react";

import invariant from "ts-invariant";

import { useGetEnrollmentBonuses } from "api/hooks/useGetEnrollmentBonuses";
import { useProfileContext } from "contexts/ProfileContext";
import { getStartOfMonth } from "utils/date";

import { EnrolledPatientsSE } from "./EnrolledPatientsSE";

export const EarningsWidgetSE: React.FC = () => {
  const { profile } = useProfileContext();

  invariant(profile, "Profile should be defined");

  const { data } = useGetEnrollmentBonuses({
    therapist_id: profile.id,
    start_date: getStartOfMonth(),
  });

  return (
    <div>
      <EnrolledPatientsSE enrollments={data?.enrollments} />
    </div>
  );
};
